/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantFrontendConfig } from '../../models/tenant-frontend-config';

export interface GetTenantFrontendConfigByShortCode$Params {

/**
 * The shortcode of the tenant
 */
  short_code: string;
}

export function getTenantFrontendConfigByShortCode(http: HttpClient, rootUrl: string, params: GetTenantFrontendConfigByShortCode$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantFrontendConfig>> {
  const rb = new RequestBuilder(rootUrl, getTenantFrontendConfigByShortCode.PATH, 'get');
  if (params) {
    rb.path('short_code', params.short_code, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantFrontendConfig>;
    })
  );
}

getTenantFrontendConfigByShortCode.PATH = '/api/v1/tenants/config/{short_code}/frontend';
